const BlogCategorySkeleton = () => {
  return (
    <section className="py-16 bg-white dark:bg-nexus-dark">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Category Filter Skeleton */}
          <div className="lg:col-span-1">
            <div className="sticky top-6 space-y-4">
              <div className="h-6 w-2/3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
              <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
              <div className="space-y-2">
                {Array.from({ length: 6 }).map((_, i) => (
                  <div
                    key={i}
                    className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Blog Card Skeletons */}
          <div className="lg:col-span-3 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="animate-pulse bg-white dark:bg-gray-800 p-6 rounded-lg shadow"
              >
                <div className="h-40 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
                <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2" />
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogCategorySkeleton;
